module.exports = __webpack_public_path__ + "static/media/eduardo-roda-lopes-198465-unsplash.4074dda0.png";